function customSelect() {
    const select = $('select:not(.is-hidden)');

    if( !select.length ) {
        return false;
    }

    select.each(function() {
        const thisSelect = $(this);
        const firstOption = thisSelect.find('option:first');
        const thisClass = thisSelect.attr('class');
        let placeholder = 'Select an option';

        if( firstOption.val() === '' ) {
            placeholder = firstOption.text();
        }

        if( thisSelect.data('icon') ) {
            placeholder = '<img src="' + thisSelect.data('icon') + '" alt="Select Icon"/>' + placeholder;
        }

        // Setup select2
        thisSelect.select2({
            placeholder: placeholder,
            minimumResultsForSearch: 10
        });

        $(thisSelect.data('select2').$container.find('.select2-selection__rendered').addClass(thisClass));

        // Hide basic select
        thisSelect.hide();
    });
}

function customNumber() {
    var numberInput = $('input[type="number"]');

    if( !numberInput.length ) {
        return false;
    }

    // Loop over all number inputs
    numberInput.each(function() {
        var thisInput = $(this);
        var thisCustomNumber;
        var isMin = thisInput.val() === thisInput.attr('min');
        var isMax = thisInput.val() === thisInput.attr('max');

        // Wrap in custom div
        thisInput.wrap('<div class="custom-number"></div>');

        // Update variable with new element
        thisCustomNumber = thisInput.parent();

        // Add increment & decrement buttons
        thisCustomNumber.append('<button type="button" class="increment' + (isMax ? ' is-disabled' : '') + '"></button><button type="button" class="decrement' + (isMin ? ' is-disabled' : '') + '"></button>');
    });

    addCustomNumberEvents();
}

function addCustomNumberEvents() {
    var customNumberButton = $('.custom-number button');
    var customNumberInput = $('.custom-number input');

    customNumberButton.on('click', function() {
        var thisButton = $(this);
        var thisContainer = thisButton.parent();
        var thisInput = thisContainer.find('input');
        var thisValue = parseInt(thisInput.val());
        var isIncrement = thisButton.hasClass('increment') ? true : false;

        // Change value
        isIncrement ? thisInput.val(thisValue + 1) : thisInput.val(thisValue - 1);

        // Validate input
        validateNumberInput(thisInput);
    });

    customNumberInput.on('keyup', function() {
        validateNumberInput($(this)); 
    });
}

function validateNumberInput(input) {
    var thisMin = parseInt(input.attr('min'));
    var thisMax = parseInt(input.attr('max'));
    var thisValue = parseInt(input.val());
    var isMin = thisValue === thisMin;
    var isMax = thisValue === thisMax;
    var thisIncrement = input.parent().find('.increment');
    var thisDecrement = input.parent().find('.decrement');

    // If incorrect values, reset.
    if( thisValue < thisMin ) {
        input.val(thisMin ? thisMin : 0);
    } else if( thisValue > thisMax ) {
        input.val(thisMax ? thisMax : 1);
    }

    isMin ? thisDecrement.addClass('is-disabled') : thisDecrement.removeClass('is-disabled');
    isMax ? thisIncrement.addClass('is-disabled') : thisIncrement.removeClass('is-disabled');

    // Trigger change of input after validation
    input.trigger('change');
}

function uploadFile(file) {
    const url = 'https://assets.sgi-glass.co.uk/upload.php';
    const fileName = file.val().split('\\').pop();
    const formData = new FormData();
    const autofill = $('input[name="' + file.data('autofill') + '"]');
    const errorMessage = 'Failed to upload file. Please check the file size (5MB Limit) and try again.';
    const field = $('.custom-file');
    const label = file.siblings('span');

    // Add attached file to form data
    formData.append('file', file[0].files[0]);

    // Post data to external server
    $.post({
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        error: function() {
            alert(errorMessage);
        },
        success: function(data) {
            if (data === 'false') {
                alert(errorMessage);
            } else {
                autofill.val(data);
                label.text('Attached - ' + fileName);
                field.addClass('is-uploaded');
            }
        }
    });
}

function customFile() {
    $('input[type="file"]').on('change', function() {
        const thisInput = $(this);

        if (thisInput.val()) {
            uploadFile(thisInput);
        }
    });
}

// Spam protection - Honeypot and minimum submission time
function initSpamProtection() {
    console.log('Initiate Spam Protection')

    // Set form load time for all forms with spam protection
    $('.product-enquiry form, .contact-box form').each(function() {
        const $form = $(this);
        const $loadTimeInput = $form.find('input[name="contact[form_load_time]"]');

        if ($loadTimeInput.length) {
            $loadTimeInput.val(Date.now());
        }
    });

    // Validate honeypot and minimum submission time on form submit
    $('.product-enquiry form, .contact-box form').on('submit', function(e) {
        const $form = $(this);
        const $honeypotField = $form.find('input[name="contact[website]"]');
        const $loadTimeInput = $form.find('input[name="contact[form_load_time]"]');

        console.log('Form submit triggered');

        // Check honeypot field - if filled, it's a bot
        if ($honeypotField.length && $honeypotField.val().trim() !== '') {
            e.preventDefault();
            e.stopImmediatePropagation();
            alert('Spam detected. Please try again.');
            console.log('Spam detected. Please try again.');
            return false;
        }

        // Check minimum submission time (3 seconds minimum)
        if ($loadTimeInput.length && $loadTimeInput.val()) {
            const loadTime = parseInt($loadTimeInput.val());
            const currentTime = Date.now();
            const timeElapsed = (currentTime - loadTime) / 1000; 

            console.log('Time elapsed: ' + timeElapsed + ' seconds');

            if (timeElapsed < 3) {
                e.preventDefault();
                e.stopImmediatePropagation();
                alert('Please wait a moment before submitting the form.');
                console.log('Minimum submission time not met: ' + timeElapsed + ' seconds');
                return false;
            }
        }

        console.log('Form validation passed, allowing submission');
    });
}

$(document).ready(function() {
    customSelect();
    customNumber();
    customFile();
    initSpamProtection();
});